<template>
  <span
    v-if="data.bovineDoneCount && data.bovineCount === data.bovineDoneCount"
    class="service-done"
  >
    Concluído
  </span>
  <span v-else-if="data.bovineDoneCount > 0">
    Parcial ({{ data.bovineDoneCount }}/{{ data.bovineCount }})
  </span>
  <span v-else>Pendente</span>
</template>

<script>
export default {
  name: 'ServiceSituation',
  props: {
    data: Object,
  },
};
</script>

<style lang="scss" scoped>
.service-done {
  color: #689f38;
}
</style>